module.exports = __webpack_public_path__ + "static/media/emily-nham.69f08390.png";